export const BOOTSTRAP_FORMS = 'BOOTSTRAP_FORMS'
export const UPDATE_FORM = 'UPDATE_CURRENCY'
